module.exports = __webpack_public_path__ + "static/media/volly.9c43e79a.png";